import { io } from "socket.io-client";
import backendUrl from "./backendUrl";

export const socket = io(backendUrl());
